import Inputmask from "inputmask";

export const presenceErrorClass = (errorMessage) => {
  return( errorMessage ? 'is-invalid' : '' )
}

export const isEmail = (email = null) => {
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 return regex.test(email);
}

export const isMobile = (mobile = null) => {
  const regex = /^04(\s?[0-9]{2}\s?)([0-9]{3}\s?[0-9]{3}|[0-9]{2}\s?[0-9]{2}\s?[0-9]{2})$/
  return regex.test(mobile);
}

// Validation. It checks if value passed is a valid number.
export const isNumericOnly = (numeric = null) => {
  const validDecimal = /^\d+\.\d+$/
  const validInt = /^\d+$/
  numeric = numberClearCommas(numeric)
  return validInt.test(numeric) || validDecimal.test(numeric)
}

// Active Validation. Prevents you to enter a char that is not a number
export const allowNumericOnly = (e) => {
  if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
    e.preventDefault();
  }
}

export const numberWithCommas = (e) => {
  const value = e.currentTarget.value
  e.currentTarget.value = numberAddCommas(value)
}

// Removes previously applied commas and applies new ones
export const numberAddCommas = (value) => {
  if (value == undefined ) {
    return ''
  } else {
    let withoutCommas = numberClearCommas(value.toString())
    return withoutCommas.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
}

export const numberClearCommas = (value) => {
  if (value == undefined) {
    return ''
  } else {
    return value.toString().replace(/,/g, '')
  }
}

export const getAge = (dateString) => {
  var today = new Date();
  dateString = dateString.split('/')
  var birthDate = new Date(dateString[2], dateString[1]-1, dateString[0]);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export const inValidDate = (date) => {
  let dateString = date.split('/')
  dateString = new Date(dateString[2], dateString[1]-1, dateString[0]);
  return isNaN(dateString.getFullYear())
}

export const getDateInputmask = (format, form, addYear = 0) => {
  const today = new Date()
  let inputmask = null
  let year = today.getFullYear() + addYear
  if (format == 'mm/yyyy') {
    const maxYear = '12/' + year
    inputmask = new Inputmask({alias: 'datetime', inputFormat: format, min: '01/1930', max: maxYear});
  } else {
    const maxYear = '31/12/' + year
    inputmask = new Inputmask({alias: 'datetime', inputFormat: format, min: '01/01/1910', max: maxYear});
  }
  return (inputmask != null) ? inputmask.mask(form) : null;
}
